import { atom } from 'jotai';

/**
 * Whether listing→detail view transitions are enabled (the
 * `revamp_2026` CMS flag). Set once at the app root (RootPage
 * Body, like `_displayModeAtom`); tiles and the detail hero read it to decide
 * whether to opt navigations into a view transition, claim the shared hero
 * snapshot name and request the overlay presentation.
 *
 * Defaults off, so surfaces that never set it (Business Manager, unit tests)
 * keep plain navigations.
 */
export const uiContextAtomViewTransitionsEnabled = atom(false);

/**
 * Whether article tiles specifically may claim the `article-hero` snapshot.
 * Requires the flag above AND the article detail revamp: the legacy article
 * page carries no `article-hero` element, so a tile that claims the name
 * while the revamp is off transitions into nothing and the `:only-child`
 * CSS fallback cross-fades the whole outgoing page instead. Set at the app
 * root beside the flag above; defaults off like it.
 */
export const uiContextAtomArticleViewTransitionsEnabled = atom(false);
